import { render, staticRenderFns } from "./b2bProvider.vue?vue&type=template&id=f13e3200&scoped=true"
import script from "./b2bProvider.vue?vue&type=script&lang=js"
export * from "./b2bProvider.vue?vue&type=script&lang=js"
import style0 from "./b2bProvider.vue?vue&type=style&index=0&id=f13e3200&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f13e3200",
  null
  
)

export default component.exports